export const {
  REACT_APP_USER,
  REACT_APP_AUTH,
  REACT_APP_BASE_URL,
  REACT_APP_SUFFIX_BASE_URL,
  REACT_APP_REPORT_BASE_URL,
} = process.env;
